import React from 'react';

import { MCButton, SearchTextField, Spinner, TabMenu, View } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import AnalysesList from 'src/components/analyse/list';
import TreatmentsList from 'src/components/treatments/list';
import TimelineList from 'src/components/timeline/list';

import { lang, permissions, withRouter } from 'src/helpers';
import { PatientInfoPanel } from 'src/components/complex';

import model from './model';

import LANG_CONST from 'src/helpers/lang/const';
import treatmentsModel from './treatmentsModel';
import analysesModel from './analysesModel';
import timelineModel from './timelineModel';
import { BASE_ICONS } from 'src/components/svg';

const tabs = [
  { id: 'analyses', name: 'Analyses' },
  { id: 'treatment', name: 'Treatment' },
  { id: 'timeline', name: 'Diary' }
];

class PatientsAnalyse extends BaseComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    model.subscribe(this.subscription);
    model.on('accountSwitched', this.init);
    this.init();
  }

  init = () => {
    if (this.props.router.params.id) {
      model.loadDetail(parseInt(this.props.router.params.id), () => this.back());
    }
  };

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('accountSwitched', this.init);
  }

  renderPatient = () => {
    const { patient } = model.state;

    return (
      <div className={'mc-container-content__body-right'} style={{ marginTop: 20, height: 'auto' }}>
        <PatientInfoPanel
          patient={{ ...patient }}
          viewProfile={() =>
            this.navigate(permissions.PAGES.PATIENTS_DETAIL_PAGE.match(patient.id))
          }
          template={2}
          hideHeader={true}
        />
      </div>
    );
  };

  getActiveModel = () => {
    const tab = model.input('tab');
    return tab === 'treatment'
      ? treatmentsModel
      : tab === 'analyses'
        ? analysesModel
        : timelineModel;
  };

  render() {
    const { patient } = model.state;

    const tab = model.input('tab');
    return (
      <div className={'mc-container-content'}>
        <div className={'mc-container-content__header mc-flex-15'}>
          <MCButton
            onClick={this.back}
            iconname={BASE_ICONS.BACK_ARROW}
            circle
            primary
            dark
            width={40}
          />
          <span className={'mc-grow'}>{lang.t(LANG_CONST.titles.analyses)}</span>
          <SearchTextField
            width={300}
            template={'2'}
            onChange={this.getActiveModel().handleChangeSearch}
            value={this.getActiveModel().listInput('search')}
          />
        </div>
        {!patient ? (
          <div className={'mc-flex'}>
            <Spinner />
          </div>
        ) : (
          <div className={'mc-container-content__body'}>
            <View style={{ position: 'relative' }}>
              <TabMenu
                tabs={tabs}
                tab={{ id: tab }}
                setTab={(tab) => model.handleChange('tab', tab.id)}
              />
              {/*{tab === 'analyses' && (*/}
              {/*  <MCButton*/}
              {/*    style={{ position: 'absolute', top: 15, right: 15 }}*/}
              {/*    medium*/}
              {/*    dark*/}
              {/*    primary*/}
              {/*    radius*/}
              {/*    onClick={() => {*/}
              {/*      analysesModel.resetAddAnalyse();*/}
              {/*      popupModel.setActivePopup(permissions.ACTIONS.ANALYSES_ADD_BUTTON.key, {*/}
              {/*        active: true,*/}
              {/*        component: AddAnalyse,*/}
              {/*        props: { model: analysesModel }*/}
              {/*      });*/}
              {/*    }}*/}
              {/*    label={LANG_CONST.buttons.add_analyses}*/}
              {/*  />*/}
              {/*)}*/}
            </View>
            <View style={{ flexDirection: 'row', flex: 1 }}>
              <div className={'mc-tab-box-opacity mc-grow'}>
                <div
                  className={
                    'mc-tab-content mc-flex-col ' + (tab === 'treatment' ? '' : 'mc-inactive')
                  }
                >
                  <TreatmentsList
                    model={treatmentsModel}
                    router={this.props.router}
                    onlyMine={true}
                    showDoctor={true}
                  />
                </div>
                <div
                  className={
                    'mc-tab-content mc-flex-col ' + (tab === 'analyses' ? '' : 'mc-inactive')
                  }
                >
                  <AnalysesList model={analysesModel} onlyMine={true} showAi={false} />
                </div>
                <div
                  className={
                    'mc-tab-content mc-flex-col ' + (tab === 'timeline' ? '' : 'mc-inactive')
                  }
                >
                  <View />
                  <TimelineList
                    onlyMine={true}
                    enableAdd={false}
                    showCategory={false}
                    selectJourney={timelineModel.selectJourney}
                    journeys={timelineModel.listInput('journeys') || []}
                    journey={timelineModel.listInput('journey')}
                    journeyId={timelineModel.listInput('journeyId')}
                    model={timelineModel}
                  />
                </div>
              </div>
              {this.renderPatient()}
            </View>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(PatientsAnalyse);
